import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { MenuLink } from './MenuLink';
import { SubmenuLink } from './submenu/SubmenuLink';

export const MenuLinks = ({ menuItems, locale }: any) => {
  return (
    <ul
      className={classNames(
        'MenuLinks flex flex-col',
        'list-none xl:flex-row xl:items-center xl:gap-16',
        'xl:mr-24 xxl:mr-40', //Keep the margin for all except the left one
      )}
    >
      {menuItems?.map((menuItem: any, key: number) => {
        if (menuItem.internalUrl)
          return (
            <MenuLink
              key={key}
              menuItem={menuItem}
              locale={locale}
              index={key}
            />
          );
        if (menuItem.submenuColumns?.length)
          return (
            <SubmenuLink
              key={key}
              menuItem={menuItem}
              locale={locale}
              index={key}
            />
          );
        return null;
      })}
    </ul>
  );
};
